import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { JobOfferRoutingModule } from './job-offer-routing.module';
import { ListJobOfferComponent } from './components/list-job-offer/list-job-offer.component';
import { AddOfferComponent } from './components/add-offer/add-offer.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { EsnAbonneViewsOfferComponent } from './components/esn-abonne-views-offer/esn-abonne-views-offer.component';
import { RouterModule } from '@angular/router';
import { PaginationModule } from './../../shared/components/pagination/pagination.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldErrorModule } from './../../shared/components/shared-field-error/field-error.module';
import { DetailsOfferComponent } from './components/details-offer/details-offer.component';
import { ListecandidatureComponent } from './components/listecandidature/listecandidature.component';
import { CandidatureoffreemploiComponent } from './components/candidatureoffreemploi/candidatureoffreemploi/candidatureoffreemploi.component';
import { AddTestOfferComponent } from './components/add-test-offer/add-test-offer.component';
import { AddBaremeComponent } from './components/add-bareme/add-bareme.component';
import { AddTestWegestuComponent } from './components/add-test-wegestu/add-test-wegestu.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { QuillModule } from 'ngx-quill';
import { SuggestionComponent } from './components/suggestion/suggestion.component';
import { DossierCandidatureComponent } from './dossier-candidature/dossier-candidature.component';
import { CalendarModule } from 'primeng/calendar';
import localeFr from '@angular/common/locales/fr';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import {SharedModule} from 'app/shared/shared.module';
import { AddConsultantModalComponent } from '@main/add-consultant-modal/add-consultant-modal.component';
import { MatMenuModule } from '@angular/material/menu';
import { EditOffreComponent } from './components/edit-offre/edit-offre.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
const components = [
  ListJobOfferComponent,
  AddOfferComponent,
  EsnAbonneViewsOfferComponent,
  DetailsOfferComponent,
  ListecandidatureComponent,
  CandidatureoffreemploiComponent,
  AddTestOfferComponent,
  AddBaremeComponent,
  AddTestWegestuComponent,
  SuggestionComponent,
  DossierCandidatureComponent,
  EditOffreComponent
]

@NgModule({
  declarations: [
    components
  ],
  imports: [
    CommonModule,
    AddConsultantModalComponent,
    JobOfferRoutingModule,
    NgSelectModule,
    RouterModule,
    PaginationModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    FieldErrorModule,
    CalendarModule,
    MatFormFieldModule, 
    MatChipsModule, 
    MatIconModule,
    MatInputModule,
    SharedModule,
    MatMenuModule,
    MatTooltipModule,
    ModalModule.forRoot(),
    QuillModule.forRoot({
      modules: {
        syntax: true,
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'], // toggled buttons
          ['blockquote', 'code-block'],

          [{ header: 1 }, { header: 2 }], // custom button values
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
          [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
          [{ direction: 'rtl' }], // text direction

          [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],

          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],

          ['clean'], // remove formatting button
        ],
      },
    }),
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'fr-FR' }]

})
export class JobOfferModule {
  constructor() {
    registerLocaleData(localeFr);
  }
}
